// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__39ae1","colCheckbox":"styles_colCheckbox__3vryr"};